module.exports = __webpack_public_path__ + "toBride2-we-b-n.29b587c8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/toBride2-we-b-n.jpg
// module id = EQpl
// module chunks = 0